//财务管理相关接口
import request from '@/utils/request'


/**
 * 获取支付管理列表
 * @param add_id 总运单id
 * @param status 支付状态  0全部1未支付2已支付
 * @param xiugai 审核状态 0全部1未修改1修改
 * @param time 卸货时间 区间
 * @param sjxm 司机姓名
 * @param cph 车牌号
 * @param id 分运单
 * **/
export function getPaymentManagementList(params = {}) {
    return request({
        url: '/api/shipper/paymentManagement',
        method: 'get',
        params
    })
}

//获取支付订单详情
export function paymentBillDetail(params = {}) {
    return request({
        url: '/api/shipper/paymentBillDetail',
        method: 'get',
        params
    })
}

//保存支付订单
export function savePaymentBill(data = {}) {
    return request({
        url: '/api/shipper/savePaymentBill',
        method: 'post',
        data
    })
}

//修改支付订单
export function updateShipperPaymentBill(data = {}) {
    return request({
        url: '/api/shipper/updateShipperPaymentBill',
        method: 'post',
        data
    })
}


//订单结算信息
export function orderSettlementInformation(params = {}) {
    return request({
        url: '/api/shipper/orderSettlementInformation',
        method: 'get',
        params
    })
}

//获取货主银行信息
export function bankInformation(params = {}) {
    return request({
        url: '/api/shipper/bankInformation',
        method: 'get',
        params
    })
}

//获取支付结果验证
export function payResultList(params = {}) {
    return request({
        url: '/api/shipper/payResultList',
        method: 'get',
        params
    })
}

//总公司支付 中原银行
export function payBill(data = {}) {
    return request({
        url: '/api/shipper/payBill',
        method: 'post',
        data
    })
}

/**
 * 资金调拨列表
 * @params add_id 总运单id
 * @params sjxm 司机姓名
 * @params cph 车牌号
 * @params id 分运单
 * @params fleet_transfer_status 是否转账给车队长 0全部1未转账1转账
 * 
 * **/
export function fundTransfer(params = {}) {
    return request({
        url: '/api/shipper/fundTransfer',
        method: 'get',
        params
    })
}

//批量订单获取对应车队长信息
export function getCarPersonBank(data = {}) {
    return request({
        url: '/api/shipper/getCarPersonBank',
        method: 'post',
        data
    })
}

//货主批量转账车队长
export function batchTransfer(data = {}) {
    return request({
        url: '/api/shipper/batchTransfer',
        method: 'post',
        data
    })
}


/**
 * 发票管理列表
 * @params yund_id 分运单id
 * @params status 0全部1待申请2申请中3已开票
 * @params time 时间
 * @params invoice_no 发票号码
 * @params fleet_transfer_status 是否转账给车队长 0全部1未转账1转账
 * 
 * **/
export function invoicesList(params = {}) {
    return request({
        url: '/api/shipper/invoicesList',
        method: 'get',
        params
    })
}

/**申请开票
 * @param id 231528，231528
 * **/
export function applicationInvoices(data = {}) {
    return request({
        url: '/api/shipper/applicationInvoices',
        method: 'post',
        data
    })
}

/**发票明细
 * **/
export function invoiceDetails(params = {}) {
    return request({
        url: '/api/shipper/invoiceDetails',
        method: 'get',
        params
    })
}

/**发票明细详情
 * @param batch_number 批次号
 * **/
export function invoiceSubDetails(params = {}) {
    return request({
        url: '/api/shipper/invoiceSubDetails',
        method: 'get',
        params
    })
}

/**
 * 批量支付详情
 * @param id 
 */
export function getBatchPaymentDetail(params = {}) {
    return request({
        url: "/api/shipper/getBatchPaymentDetail",
        method: 'get',
        params
    })
}

/**
 * 批量支付
 * @param {id,pwd} data 
 * @returns 
 */
export function BatchPayment(data = {}) {
    return request({
        url: '/api/shipper/BatchPayment',
        method: 'post',
        data
    })
}
/**
 * 分公司支付
 * @param {} data 
 * @returns 
 */
export function payAhBill(data = {}) {
    return request({
        url: 'api/shipper/payAhBill',
        method: 'post',
        data
    })
}

/**
 * 中原银行第一次支付(货主pc端)
 * @param {} data 
 * @returns 
 */
export function firstPayment(data = {}) {
    return request({
        url: 'api/shipper/firstPayment',
        method: 'post',
        data
    })
}

/**
 * 中原银行二次支付/全量支付
 * @param {} data 
 * @returns 
 */
export function twoPayment(data = {}) {
    return request({
        url: 'api/shipper/twoPayment',
        method: 'post',
        data
    })
}


//郑州分公司 全量支付
export function payZzBill(data = {}) {
    return request({
        url: '/api/shipper/payZzBill',
        method: 'post',
        data
    })
}

//浙江分公司
export function payZjBill(data = {}) {
    return request({
        url: '/api/shipper/payZjBill',
        method: 'post',
        data
    })
}

/**
 * 郑州分公司第一次支付(货主pc端)
 * @param {} data 
 * @returns 
 */
export function firstZzPayment(data = {}) {
    return request({
        url: 'api/shipper/firstZzPayment',
        method: 'post',
        data
    })
}

/**
 * 郑州分公司二次支付
 * @param {} data 
 * @returns 
 */
export function twoZzPayment(data = {}) {
    return request({
        url: 'api/shipper/twoZzPayment',
        method: 'post',
        data
    })
}


/**
 * 取消开票
 * @param {batch_number} data 批次号
 * @returns 
 */
export function cancelInvoices(data = {}) {
    return request({
        url: 'api/shipper/cancelInvoices',
        method: 'post',
        data
    })
}

/**
 * 批量审核
 * @param {*} data 
 * @returns 
 */
export function batchVerification(data = {}) {
    return request({
        url: "api/shipper/batchVerification",
        method: 'post',
        data
    })
}

/**
 * 支付管理导出的字段
 * @param {*} params 
 * @returns 
 */
export function exportField(params = {}) {
    return request({
        url: "api/shipper/exportField",
        method: "get",
        params
    })
}

export function exportPayField(params = {}) {
    return request({
        url: "api/shipper/exportPayField",
        method: "get",
        params
    })
}
//财务审核 已审核已支付 后再保存数据
export function updatePaymentBill(data = {}) {
    return request({
        url: '/api/shipper/updatePaymentBill',
        method: 'post',
        data
    })
}

//货主流水
export function transactionRecords(params = {}) {
    return request({
        url: "api/shipper/transactionRecords",
        method: "get",
        params
    })
}


/**
 * 获取预支付列表
 * @param status -1全部0支付中1支付成功2支付失败3.申请中4拒绝申请
 * @param time 申请时间 以2024-05-06 -2024-05-27
 * @param driver_name 司机名称
 * **/
export function advancePaymentList(params = {}) {
    return request({
        url: "api/shipper/advancePaymentList",
        method: "get",
        params
    })
}

/**
 * 预支付审核
 * @param status 1通过2拒绝
 * @param apply_id 自增申请id
 * @param passwrod 支付密码，通过必传
 * **/
export function paymentReview(data = {}) {
    return request({
        url: '/api/shipper/paymentReview',
        method: 'post',
        data
    })
}